import {
  useAdminInviteMutation,
  useGetAdminsQuery,
  useRemoveAdminMutation,
  useUpdateAdminPlanMutation,
} from '../../../api/adminApi';
import { formatDate } from '../../../../../shared/utils/date';

export interface TeamMember {
  id: number;
  email: string;
  role: string;
  status: 'active' | 'pending';
  date: string;
}

export function useTeamData() {
  const adminUser = JSON.parse(localStorage.getItem('admin_user') || '{}');
  const maxMembers = adminUser.plan === 'team' ? 2 : 1;

  const { data: response, isLoading, refetch } = useGetAdminsQuery();
  const [inviteAdmin, { isLoading: isInviting }] = useAdminInviteMutation();
  const [removeAdmin] = useRemoveAdminMutation();
  const [updatePlan] = useUpdateAdminPlanMutation();

  const activeMembers = response?.data || [];
  const members: TeamMember[] = activeMembers.map((m: any) => ({
    id: m.id,
    email: m.email,
    role: m.role === 'pending' ? 'Member' : m.role || 'Member',
    status: m.role === 'pending' ? 'pending' : 'active',
    date: formatDate(m.created_at || new Date()),
  }));

  return {
    adminUser,
    maxMembers,
    members,
    isLoading,
    refetch,
    inviteAdmin,
    isInviting,
    removeAdmin,
    updatePlan,
  };
}
